// Style
import '../../styles/main/projects.scss'
import '../../styles/main/project.scss'
import '../../styles/main/folder.scss'

// Image
import File from '../../assets/file.svg'

function Folder({ name, onOpen, isSelected }) {

    return (
        <div
            className={`folder ${isSelected ? 'selected' : ''}`}
            onClick={onOpen}
        >
            <img
                src={File}
                alt="Icône de dossier"
            />

            <p>{name}</p>
        </div>
    )
}

export default Folder